import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { FormControl, FormGroup, FormLabel, FormControlLabel, Switch as Switch$1, FormHelperText } from '@mui/material';
var _excluded = ["switchGroup", "onChange", "fullWidth"];

var Switch = function Switch(_ref) {
  var _ref$switchGroup = _ref.switchGroup,
      label = _ref$switchGroup.label,
      helperText = _ref$switchGroup.helperText,
      items = _ref$switchGroup.items,
      onChange = _ref.onChange,
      fullWidth = _ref.fullWidth,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormControl, _extends({
    fullWidth: fullWidth
  }, rest), /*#__PURE__*/React.createElement(FormGroup, null, label && /*#__PURE__*/React.createElement(FormLabel, null, label), items.map(function (_ref2) {
    var isChecked = _ref2.isChecked,
        id = _ref2.id,
        isEnabled = _ref2.isEnabled,
        color = _ref2.color,
        description = _ref2.description;
    return /*#__PURE__*/React.createElement(FormControlLabel, {
      control: /*#__PURE__*/React.createElement(Switch$1, {
        checked: isChecked,
        value: id,
        disabled: !isEnabled,
        onChange: onChange && function (event) {
          return onChange(event.currentTarget.value);
        },
        color: color
      }),
      label: description,
      key: id
    });
  })), helperText && /*#__PURE__*/React.createElement(FormHelperText, null, helperText)));
};

Switch.defaultProps = {
  fullWidth: true
};
Switch.displayName = 'Switch';
export { Switch };